export enum OptionRangeType {
    'AtLeast' = 0,
    'AtMost'  = 1,
    'Exactly' = 2,
    'Between' = 3,
    'All'     = 4,
}